/**
 * Convierte una cadena de clave anidada en un array de propiedades, manejando correctamente los índices de arrays
 * y los caracteres escapados (`\.` y `\\.`).
 *
 * - Los puntos (`.`) indican niveles de profundidad, excepto si están escapados con una barra (`\.`), en cuyo caso se mantienen como parte del nombre de la propiedad.
 * - Las secuencias `\\.` indican que se escapa la barra (`\`), por lo que el punto vuelve a actuar como separador, y la barra se conserva en la propiedad anterior.
 * - También transforma notación de array (`prop[0]`) en notación de puntos (`prop.0`).
 *
 * Ejemplos:
 * ```js
 * getSplitedPath('user.address.city') // ['user', 'address', 'city']
 * getSplitedPath('items[0].name') // ['items', '0', 'name']
 * getSplitedPath('config.escape\\.dot') // ['config', 'escape.dot']
 * getSplitedPath('escape2\\\\.dot') // ['escape2\\', 'dot']
 * getSplitedPath('key\\\\\\.final') // ['key\\.final']
 * ```
 *
 * @param {string} fieldName - La cadena de texto con notación de propiedad anidada.
 * @returns {string[]} Array con las partes individuales del path, ya separadas y con los escapes interpretados.
 */
function getSplitedPath (fieldName) {
  return fieldName
    .replace(/([^.])\[(\d+)\]/g, '$1.$2')
    .replace(/\[(\d+)\]/, '$1')
    .match(/(?:\\.|[^.])+/g)
    .map(part => part.replace(/\\(.)/g, '$1'))
}

export default getSplitedPath
